import { DelayedComponentLoader } from "@ch/components/Loaders/ComponentLoader/DelayedComponentLoader";
import { type FC, Suspense, lazy } from "react";

const PSAHistoryPage = lazy(() => import("./PSAHistoryPage"));

const PSAHistoryPageLazy: FC = () => {
  return (
    <Suspense fallback={<DelayedComponentLoader />}>
      <PSAHistoryPage />
    </Suspense>
  );
};

export default PSAHistoryPageLazy;
